import { catalogEntityOptionFlags, catalogEntityOptionFlagsEnum } from "helpers/enums";
import { flagVal } from "helpers/system";
import React, { useEffect, useState } from "react";
import { getCatalogItems } from "sources/books/dictionaries";

const hiddenFlagVal = flagVal(catalogEntityOptionFlags, catalogEntityOptionFlagsEnum.Invisible);

const TypeOptions = (props) => {
    const { typeOptions, userEntityOptions, checkBidRelation, inline } = props;
    if (!userEntityOptions) {
        return null;
    }
    return typeOptions.map((data, i) => (
        <Option
            key={i}
            inline={inline}
            item={data}
            userEntityOptions={userEntityOptions}
            checkBidRelation={checkBidRelation}
        />
    ));
};

const Option = ({ userEntityOptions, item, checkBidRelation, inline }) => {
    const [isLoading, setLoading] = useState(true);
    const [typeOption, setTypeOption] = useState();
    const option = checkBidRelation
        ? userEntityOptions.find(
              (option) =>
                  option.entityOptionId === item.entityOptionId &&
                  (option.intRelationFlags & hiddenFlagVal) !== hiddenFlagVal,
          )
        : userEntityOptions.find(
              (option) =>
              option.entityOptionId === item.entityOptionId && (option.intFlags & hiddenFlagVal) !== hiddenFlagVal,
          );

    useEffect(() => {
        if (!option) {
            return;
        }
        getCatalogItems({ preparedFilter: { externalId: option.catalogPropertyName, id: item.id } }).then((res) => {
            if (res && res.data && res.data[0]) {
                setTypeOption(res.data[0]);
            }
            setLoading(false);
        });
    }, [item.id, option]);

    if (!option) {
        return null;
    }

    if (isLoading || !typeOption) {
        return null;
    }
    return inline ? (
        <div className="b-timeline-point__city--full" style={option.order ? { order: option.order } : {}}>
            {option.displayName}: {typeOption.displayName}
        </div>
    ) : (
        <>
            <div className="show-bid__main-info--title" style={option.order && !inline ? { order: option.order } : {}}>
                {option.displayName}
            </div>
            <div
                className="show-bid__main-info--value"
                data-test-id="type-option"
                style={option.order && !inline ? { order: option.order } : {}}
            >
                {typeOption.displayName}
            </div>
        </>
    );
};

export default TypeOptions;
